/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Print_BtnInputs */

const vi_sinp_print_btn = /** @type {(inputs: Sinp_Print_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In phiếu`)
};

/**

* @param {Sinp_Print_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_print_btn = /** @type {((inputs?: Sinp_Print_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Print_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_print_btn(inputs)
});